import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const AdsCardWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 376px;
  background-color: #e9ebed;
  color: #949da6;
  @media (${mediaQuery.mobile}) {
    height: 282px;
  }
`;
